import { render, staticRenderFns } from "./productTag.vue?vue&type=template&id=b5696d4c&scoped=true&"
import script from "./productTag.vue?vue&type=script&lang=js&"
export * from "./productTag.vue?vue&type=script&lang=js&"
import style0 from "./productTag.vue?vue&type=style&index=0&id=b5696d4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5696d4c",
  null
  
)

export default component.exports